import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function NotFound() {
    const location = useLocation();

    useEffect(() => {
        console.error(
            '404 Error: User attempted to access non-existent route:',
            location.pathname,
        );
    }, [location.pathname]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-muted">
            <div className="text-center">
                <h1 className="text-4xl font-bold mb-4">404</h1>
                <p className="text-xl text-muted-foreground mb-4">Oops! Page not found</p>
                <a href="/dashboard" className="text-primary hover:underline">
                    Return to Dashboard
                </a>
            </div>
        </div>
    );
}

export default NotFound;
